import { useState } from 'react';
import FaqItem from './FaqItem';
import Toolbar from './Toolbal';

const FaqList = (props) => {
  const [openId, setOpenId] = useState(0);

  return (
        <section className="bg-white p-4 shadow-sm sm:p-5 md:p-6">
            <Toolbar 
                setOpenId={setOpenId}
                loading={props.loading}
                isEditor={props.isEditor}
                questions={props.questions}
                handleAddQuestion={props.handleAddQuestion}
                saveChangeQuestions={props.saveChangeQuestions}
            />
            <div>
                {props.questions.map((item, index) => (
                    <FaqItem
                        key={item.Id}
                        index={index + 1}
                        item={item}
                        openId={openId}
                        setOpenId={setOpenId}
                        isEditor={props.isEditor}
                        setQuestions={props.setQuestions}
                        deleteQuestion={props.deleteQuestion}
                    />
                ))}
            </div>
        </section>
  );
};

export default FaqList;
